import { LoginUserInfoModel } from '../kymw1000/vo/login-user-info.model';
import { GetInitTopModel, PermissionModel } from '../kymw1001/vo/get-init-top.model';
import { DashboardMessageInfo } from './vo/dashboard-message-info.model';
import { DashboardLockInfoList } from './vo/dashboard-lock-info.model';
import { KYMW1002Component } from './kymw1002.component';

/**
 * メインメニュー　モデルクラス
 *
 * @export KYMW1002Model
 * @class KYMW1002Model
 */
export class KYMW1002Model {
  kymw1002Component: KYMW1002Component;

  // ダッシュボード画面の取引先情報リスト
  public supplierInfoList = new Array<any>();
  // ダッシュボード画面の所属情報
  public supplierCode = '';

  // ダッシュボード画面の各種メッセージ情報リスト
  public dashboardMessageInfoList: DashboardMessageInfo = new DashboardMessageInfo();

  // ダッシュボード画面のロック情報(元データ)
  public dashboardLockInfoList: DashboardLockInfoList = null;
  // ダッシュボード画面のロック情報（表示用データ）
  public showDashboardLockInfoList: Array<any> = new Array<any>();
  // ダッシュボード画面のロック情報（編集用データ）
  public editDashboardLockInfoList: Array<any> = new Array<any>();

  // ダッシュボード画面のお知らせ
  public topInfo2: string = null;

  // ダッシュボード画面の機能許可リスト更新
  public permissionList: PermissionModel[] = null;

  // ダッシュボード画面のユーザー情報更新
  public loginUserInfo: LoginUserInfoModel = null;
  public userID: string = null;
  public authoritySetID: string = null;

  // 画面項目の活性/非活性の制御用に追加
  private readonly FULL_CONTROL: number = Number(2);
  // トップ画面から起動した機能の機能IDを保持する
  public topFuncID: string = null;
  // トップ画面から起動した機能の画面モード(更新可能/閲覧のみ)を保持する
  public topFuncReadOnlyMode: boolean = null;
  // 各画面の
  public formReadOnlyMode: Map<string, boolean> = new Map();

  /** 機能ID→機能オブジェクトとなるマップ. */
  public funcPermissionMap: Map<string, PermissionModel> = new Map();

  public colorList: Array<any> = new Array<any>();

  public resultLogPath: string = null;

  /**
   * ダッシュボード画面のロック情報取得
   *
   * @param {*} info APIレスポンスデータ（ロック情報の元データ）
   * @memberof KYMW1002Model
   */
  public getShowDashboardLockInfoList(info: DashboardLockInfoList): void {
    let i: number;
    this.showDashboardLockInfoList.length = 0;
    // ロック情報をセットする
    for (i = 0; i < info.LockInfoList.length; i++) {
      let getLockTarget: string = null;
      let lockInfo = info.LockInfoList[i];
      this.showDashboardLockInfoList.push(new Object());

      this.showDashboardLockInfoList[i]['OrderCode'] = lockInfo.OrderCode;
      this.showDashboardLockInfoList[i]['MediumType'] = lockInfo.MediumType;
      this.showDashboardLockInfoList[i]['PCode'] = lockInfo.PCode;
      this.showDashboardLockInfoList[i]['LockerId'] = lockInfo.LockerId;
      this.showDashboardLockInfoList[i]['PageId'] = lockInfo.PageId;

      // ロック先機能
      this.showDashboardLockInfoList[i]['lockFunc'] = lockInfo.ProcessName;
      // ロック先
      this.showDashboardLockInfoList[i]['LockType'] = lockInfo.LockType;
      switch (lockInfo.LockType) {
        case 'PAGE':
          getLockTarget = lockInfo.MediumType + '　' + lockInfo.OrderCode + ':' + lockInfo.PageNum + 'ページ';
          this.showDashboardLockInfoList[i]['lockTarget'] = getLockTarget;
          break;
        case 'CATALOG':
          getLockTarget = lockInfo.MediumType + ':' + lockInfo.OrderCode;
          this.showDashboardLockInfoList[i]['lockTarget'] = getLockTarget;
          break;
        case 'GOODS':
          getLockTarget = lockInfo.PCode;
          this.showDashboardLockInfoList[i]['lockTarget'] = getLockTarget;
          break;
        case 'PLANGOODS':
          getLockTarget = lockInfo.MediumType + '　' + lockInfo.OrderCode + ':' + lockInfo.PCode;
          this.showDashboardLockInfoList[i]['lockTarget'] = getLockTarget;
          break;
        case 'IMAGE':
        default:
          this.showDashboardLockInfoList[i]['lockTarget'] = '';
          break;
      }
      // ロック日時
      this.showDashboardLockInfoList[i]['lockDate'] = lockInfo.LockStartDate;
      // ロック実施者
      this.showDashboardLockInfoList[i]['lockName'] = lockInfo.LockerName;

      lockInfo = null;
    }

  }

  /**
 * ロック情報（初回起動時・更新用）
 *
 * @memberof KYMW1002Model
 */
  public getUpdLockInfo() {
    // 表示用データをクリアし、更新データを格納する
    this.showDashboardLockInfoList = new Array<any>(); // インスタンスを入れ替える
  }

  /**
   * ロック情報（削除用）
   *
   * @param index
   * @memberof KYMW1002Model
   */
  public deleteLockInfo(index: number) {
    // ロック解除の対象行を削除したデータを作成する
    this.showDashboardLockInfoList.splice(index, 1);
    // 表示用データをクリアし、更新データを格納する
    this.editDashboardLockInfoList = this.showDashboardLockInfoList;
    this.showDashboardLockInfoList.length = 0;
  }

  /**
   * ダッシュボード画面のお知らせ内容更新
   *
   * @param {*} serverData サーバから取得された<Data>タグ
   * @memberof KYMW1002Model
   */
  public updateTopInformation(serverData: any): void {
    this.topInfo2 = serverData.Rec.Information;
  }

  /**
   * ダッシュボード画面のユーザーID、権限セットID更新
   * ユーザーIDを設定する
   * 権限セットIDを設定する
   *
   * @param {*} serverData サーバから取得された<Data>タグ
   * @memberof KYMW1002Model
   */
  public updateUserInfo(serverData: LoginUserInfoModel): void {
    this.loginUserInfo = serverData;
    this.userID = serverData.UserID;
    this.authoritySetID = serverData.AuthoritySetID;
  }

  /**
   * ダッシュボード画面の機能許可リスト更新
   *
   * @param {*} serverData サーバから取得された<Data>タグ
   * @memberof KYMW1002Model
   */
  public updateFuncPermissionList(serverData: GetInitTopModel): void {
    this.permissionList = serverData.PermissionList;
    this.funcPermissionMap = new Map<string, PermissionModel>();
    this.permissionList.forEach(fp => this.funcPermissionMap.set(fp.FuncID, fp));
  }

  /**
   * 起動した機能の機能ID、画面モード(更新可能/閲覧のみ)の格納
   *
   * @param {string} funcID 機能ID
   * @returns {string}
   * @memberof KYMW1002Model
   */
  public setScreenModeOnNowFunc(funcID: string): string {
    this.topFuncID = funcID;
    const funcList: PermissionModel[] = this.permissionList;
    let i: number;
    let mode: string;

    for (i = 0; i < funcList.length; i++) {
      if (funcList[i].FuncID === this.topFuncID) {
        if (funcList[i].EnableMode === this.FULL_CONTROL.toString()) {
          this.topFuncReadOnlyMode = false;
          mode = 'false';
          this.formReadOnlyMode.set('KYMW1002', false);
        } else {
          this.topFuncReadOnlyMode = true;
          mode = 'true';
          this.formReadOnlyMode.set('KYMW1002', true);
        }
        break;
      }
    }
    return mode;
  }
}
